export const PRODUCT_ITEM_WRAPPER_CLASSES = 'px-4 pb-20 flex-shrink-0 product-item-wrapper';
export const PRODUCT_LIST_WRAPPER_CLASSES = 'd-flex mx-n4 flex-wrap';

export enum SkeletonsQuantity {
  Parity = 4,
  NonParity = 3,
}
